// export const apiUrl = "http://localhost/projet_cartel/api/";
export const apiUrl = "https://api.planning-cartelconcerts.com/";
